// Minimal Design Tokens — minimal variant
import type { ThemeDefinition } from '@vcard/shared/types';

// Hardcoded Tailwind values (browser-safe, no require())
// stone: 50=#fafaf9 400=#a8a29e   zinc: 500=#71717a 900=#18181b 950=#09090b
// violet: 900=#4c1d95

const minimalTheme: ThemeDefinition = {
  colors: {
    main:          { light: '#fafaf9', dark: '#09090b' },
    card:          { light: '#fafaf9', dark: '#09090b' },
    surface:       { light: '#fafaf9', dark: '#09090b' },
    action:        { light: '#4c1d95', dark: '#fafaf9' },
    actionHover:   { light: '#fafaf9', dark: '#4c1d95' },
    confirm:       { light: '#111111', dark: '#f5f5f5' },
    confirmHover:  { light: '#1f1f1f', dark: '#e5e5e5' },
    textPrimary:   { light: '#18181b', dark: '#fafaf9' },
    textSecondary: { light: '#18181b', dark: '#fafaf9' },
    textMuted:     { light: '#18181b', dark: '#fafaf9' },
    border:        { light: '#71717a', dark: '#a8a29e' },
    inputBg:       { light: '#ffffff', dark: '#111114' },
  },
  borderRadius: {
    card: '40px',
    container: '25px',
    page: '1.5rem',
    button: '9999px',
    input: '0.75rem',
    badge: '6px',
    full: '9999px',
  },
  borderWidth: {
    default: '1px',
    thick: '2px',
    avatar: '6px',
    device: '8px',
  },
  textures: {
    main:    { light: '', dark: '', size: '0', blendLight: 'normal', blendDark: 'normal', opacityLight: 0, opacityDark: 0 },
    surface: { light: '', dark: '', size: '', blendLight: 'multiply', blendDark: 'overlay', opacityLight: 0, opacityDark: 0 },
    card:    { light: '', dark: '', size: '', blendLight: 'multiply', blendDark: 'overlay', opacityLight: 0, opacityDark: 0 },
  },
};

export default minimalTheme;
